/**
 * Stub de navegador para `lzma`.
 *
 * `@dblimp/bs5`'s `FileField` importa `lzma`, que es un módulo de Node que usa
 * `__dirname`/`fs` y no puede ejecutarse en el navegador. MANGIBONE no usa
 * file-fields (subida de binarios), así que se sustituye por este stub.
 *
 * El alias vive en `vite.config.ts` (`resolve.alias.lzma`).
 */
const unsupported = () => {
  throw new Error(
    "lzma no está disponible en el navegador (stub). MANGIBONE no usa FileField."
  );
};

const stub = {
  compress: unsupported,
  decompress: unsupported,
  compressFile: unsupported,
  decompressFile: unsupported,
  LZMA_WORKER: undefined,
  lzma: unsupported,
};

export default stub;
